module.exports = __webpack_public_path__ + "img/plus_btn.7f1acfdf.png";